import { GetTeamCreationBillingPreviewResponse } from '@pkg/types/api'

export type PersonalPlanPreview = NonNullable<
  GetTeamCreationBillingPreviewResponse['personalPlan']
>

const planNames: Record<PersonalPlanPreview['plan'], string> = {
  PRO: 'Pro',
  BUSINESS: 'Business',
}

const periodNames: Record<
  NonNullable<PersonalPlanPreview['billingPeriod']>,
  string
> = {
  MONTHLY: 'month',
  YEARLY: 'year',
}

export const formatMoney = (minorUnits: number, currency: string) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: minorUnits % 100 === 0 ? 0 : 2,
  }).format(minorUnits / 100)

const describePlanPrice = ({
  price,
  currency,
  billingPeriod,
}: PersonalPlanPreview) => {
  if (price === null || !currency || !billingPeriod) {
    return ''
  }
  return ` (${formatMoney(price, currency)}/${periodNames[billingPeriod]})`
}

/**
 * Explains, before the team is created, that the personal subscription ends
 * and the team has to be subscribed separately.
 */
export const describeTeamCreationBillingImpact = (
  personalPlan: PersonalPlanPreview,
) => {
  const sentences = [
    `Your ${planNames[personalPlan.plan]} plan${describePlanPrice(personalPlan)} will be cancelled when you create the team.`,
  ]
  if (personalPlan.unusedCredit && personalPlan.currency) {
    sentences.push(
      `The unused ${formatMoney(personalPlan.unusedCredit, personalPlan.currency)} will be credited to the team.`,
    )
  }
  sentences.push(
    'The team starts on the Free plan — to keep recording interviews without a break, subscribe the team on the next step.',
  )
  return sentences.join(' ')
}
